var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconStatusUnsubscribed = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2.5a9.5 9.5 0 1 1 0 19 9.5 9.5 0 0 1 0-19zm3.573 6.167a.833.833 0 0 0-1.179 0l-2.277 2.277-2.276-2.277a.833.833 0 1 0-1.179 1.178l2.277 2.277-2.277 2.277a.833.833 0 0 0 0 1.178l.086.075a.834.834 0 0 0 1.093-.075l2.276-2.277 2.277 2.277a.833.833 0 0 0 1.179-1.178l-2.278-2.277 2.278-2.277a.833.833 0 0 0 0-1.178z",
    fill: "#02607F"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconStatusUnsubscribed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-status-unsubscribed.b6f0648546373e015fff5dbdd479c36d.svg";